export const FIELDS = {
  ID: 'id',
  LINE_NUM: 'lineNum',
  RMAID: 'rmaId',
  RMANO: 'rmaNo',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  VENDOR_ID: 'vendorId',
  VENDOR_NAME: 'vendorName',
  VENDOR_RMAID: 'vendorRmaId',
  VENDOR_RMALINE_ID: 'vendorRmaLineId',
  INVENTORY_ID: 'inventoryId',
  INVOICE_LINE_ID: 'invoiceLineId',
  SALES_ORDER_ID: 'salesOrderId',
  SOLINE_ID: 'soLineId',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  SOLINE_SCHEDULE_ID: 'soLineScheduleId',
  POLINE_ID: 'poLineId',
  REQUIREMENT_LINE_ID: 'requirementLineId',
  QUOTE_LINE_ID: 'quoteLineId',
  PART_NUMBER: 'partNumber',
  MFG_NAME: 'mfgName',
  DATE_CODE: 'dateCode',
  CUSTOMER_PN: 'customerPn',
  QTY_INVOICED: 'qtyInvoiced',
  QTY_RETURNING: 'qtyReturning',
  PRICE_INVOICED: 'priceInvoiced',
  RMAREASON_NAME: 'rmaReasonName',
  PRICE: 'price',
  TOTAL_PRICE: 'totalPrice',
  DESCRIPTION: 'description',
  QTY_RECEIVED: 'qtyReceived',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  CONDITION_NAME: 'conditionName',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
  HARMONIZED_CODE: 'harmonizedCode',
  LEAD_FREE: 'leadFree',
  LOT_CODE: 'lotCode',
  PACKAGE: 'package',
  PIECE_PER_PKG: 'piecePerPkg',
  CONDITION_ID: 'conditionId',
  CUSTOMER_PO: 'customerPo',
  RMADATE: 'rmaDate',
  RMATERMS_ID: 'rmaTermsId',
  RMATERMS_NAME: 'rmaTermsName',
  CONTACT_ID: 'contactId',
  CONTACT_FULL_NAME: 'contactFullName',
  SALES_PERSON_USER_ID: 'salesPersonUserId',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  APPROVED_BY_USER_FULL_NAME: 'approvedByUserFullName',
  PART_ID: 'partId',
  NSNNUMBER: 'nsnNumber',
  ALT_NUMBER: 'altNumber',
  SKU: 'sku',
  MANUFACTURER_ID: 'manufacturerId',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  PACKAGE_ID: 'packageId',
  UO_MID: 'uoMId',
  UOM: 'uom',
  TEMP_RATING: 'tempRating',
  PART_COMMENTS: 'partComments',
  COST: 'cost',
  TOTAL_COST: 'totalCost',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  CURRENCY_SYMBOL: 'currencySymbol',
  REVISION: 'revision',
  WAREHOUSE_ID: 'warehouseId',
  WAREHOUSE_NAME: 'warehouseName',
  LOCATION: 'location',
  RMAREASON_ID: 'rmaReasonId',
  COMMENTS: 'comments',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  IS_SERVICE: 'isService',};